import { render } from "./FormCustomerPassword.vue?vue&type=template&id=58bb20a6"
import script from "./FormCustomerPassword.vue?vue&type=script&lang=js"
export * from "./FormCustomerPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__